<template>
    <NuxtLink :to="relativeUrl(article.full_url)" class="flex flex-col gap-6 group">
        <div class="h-58 relative rounded-xl shrink-0 w-full overflow-hidden">
            <NuxtImg
                :src="article.photo.src"
                :alt="article.name"
                width="340"
                height="232"
                fit="cover"
                class="absolute inset-0 w-full h-full object-cover rounded-xl"
            />
        </div>
        <div class="flex lg:flex-1 flex-col gap-5 lg:gap-6 text-brand-dark-blue">
            <div class="flex flex-col gap-2.25 lg:gap-3.25">
                <p class="text-xs font-medium leading-none opacity-70">
                    {{ article.category }}
                </p>
                <h3 class="text-lg lg:text-xl font-semibold leading-6.25 lg:leading-tight line-clamp-3">
                    {{ article.name }}
                </h3>
            </div>
            <span class="lg:mt-auto text-15 lg:text-base underline underline-offset-3">
                {{ t('blog.readMore') }}
            </span>
        </div>
    </NuxtLink>
</template>

<script setup lang="ts">
import type { BlogArticle } from '~/types'

defineProps<{
    article: BlogArticle
}>()

const { t } = useI18n()
</script>
